import { useQuery } from "@tanstack/react-query"
import instance from "../../instance"
export interface IFetchQuestionFilters{
category_id?:string,
is_active?:boolean,
flag_status?:string,
limit?:number,
offset?:number
    search?:string
user_id?:string | number

}
interface FetchQuestionResponse{
Questions:Questions[],
page: number
page_size: number
total_Questions:number 
}
interface Questions{
    
        text: string;
        answer: string;
        user_id: number;
        category_id: number;
        is_active: boolean;
        flag_status: string;
        id: number;
        created_at: null | string;
      

}
export const useFetchQuestions=(payload:IFetchQuestionFilters)=>{
    const fetchQuestions= async():Promise<Questions[]>=>{
const {data}= await instance.get(`/questions?category_id=${payload.category_id}&is_active=${payload.is_active}&flag_status=${payload.flag_status}&limit=${payload.limit}&offset=${payload.offset}&search=${payload.search}&user_id=${payload.user_id}`)
return data

    }
    const query= useQuery({
        queryFn:fetchQuestions,
        queryKey:['Questions', payload]
    })
return query
}